<script setup>
import '@campact/camper/core/CmprFormHint';
import { computed } from 'vue';

import CmprInput from '@cta/frontend/components/CmprInput.vue';

const model = defineModel({ type: String });

const props = defineProps({
  analyticsContext: {
    type: String,
    default: 'email-address',
  },
  analyticsIdPrefix: {
    type: String,
    default: 'donate-call',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: undefined,
  },
  inputClass: {
    type: String,
    default: undefined,
  },
});

const emit = defineEmits(['input', 'commit']);

const fieldId = computed(() => `${props.analyticsIdPrefix}-form-contact-details-emailaddress-field`);
</script>

<template>
  <CmprInput
    :id="fieldId"
    v-model="model"
    autocomplete="email"
    :class="[inputClass, { 'is-invalid': !!error }]"
    :data-analytics-context="analyticsContext"
    :data-analytics-id="fieldId"
    data-analytics-inner-text="emailaddress"
    :disabled="disabled"
    placeholder="E-Mail"
    @input="emit('input')"
    @keydown.enter="emit('commit')"
  />

  <cmpr-form-hint
    v-if="error"
    variant="error"
  >
    {{ error }}
  </cmpr-form-hint>
</template>
